<div class="container reports">
  <div class="row header mb-2">
      <div class="title">Reports</div>
  </div>
  <div class="row">

    <ul class="nav nav-tabs" role="tablist">
      <li class="nav-item" role="presentation">
        <button
          type="button"
          class="nav-link active">Archived Rosters</button>
      </li>
    </ul>


  </div>

  <div class="row mt-3">
    <div class="col">
      <app-archived-rosters></app-archived-rosters>
    </div>
  </div>
</div>
